import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CartComponent from 'us_quickturn_prototype_pcb/CartComponent';
import { buildProjectNumber } from 'shared/product_tabs/cart/utils/builders';
import { deleteFabrication } from 'us_quickturn_prototype_pcb/pcb_fabrication/slice/fabricationSlice';
import { buildFabricationForm } from 'us_quickturn_prototype_pcb/pcb_fabrication/utils/builder';
import { validate, validateProject } from 'us_quickturn_prototype_pcb/pcb_fabrication/slice/validators';
import {
  selectFabricationCurrentVariant,
  selectFabricationDataForCart,
  selectFabricationParameters,
  selectFabricationLoading,
} from 'us_quickturn_prototype_pcb/pcb_fabrication/slice/selectors';

const Cart = () => {
  const dispatch = useDispatch();

  const currentFabricationVariant = useSelector(selectFabricationCurrentVariant);
  const parameters = useSelector(selectFabricationParameters);
  const loading = useSelector(selectFabricationLoading);

  const cleanUp = () => dispatch(deleteFabrication());
  const fabricationValidate = () => dispatch(validate());
  const projectValidate = () => dispatch(validateProject());

  const projectNumber = () => Spree.project_number || buildProjectNumber(`PL${currentFabricationVariant}`, 24);
  const projectReference = () => 'us-quickturn-prototype-pcb';

  return (
    <CartComponent
      fabricationSelector={selectFabricationDataForCart}
      fabricationCleanUp={cleanUp}
      fabricationValidate={fabricationValidate}
      projectValidate={projectValidate}
      buildFabricationForm={buildFabricationForm}
      projectNumber={projectNumber}
      projectReference={projectReference}
      parameters={parameters}
      loading={loading} />
  );
};

export default Cart;
